import { PlayablePlaybackOption } from '../../queries/ats/titles/types/playback-option';
import { Title } from '../../queries/ats/titles/types/title';
import { getPercent } from '../../utils/commonUtils';
import { TrackerEvent } from '../interfaces/tracker-event';

interface PlaybackEndedProperties {
  master_id: string;
  content_title: string;
  content_type: Title['type'];
  genres: string[];
  episode_number: number | undefined;
  season_number: number | undefined;
  series_id: string | undefined;
  provider_title_id: string;
  service_name: string;
  service_type: PlayablePlaybackOption['serviceType'];
  referral_id: string;
  bookmark_seconds: number | undefined;
  bookmark_percent: number | undefined;
  is_trailer: boolean;
}

export class PlaybackEndedEvent implements TrackerEvent<PlaybackEndedProperties> {
  public name = 'playback_ended';
  public properties: PlaybackEndedProperties;

  constructor(
    title: Title,
    playbackOption: Pick<PlayablePlaybackOption, 'providerTitleId' | 'providerName' | 'serviceType'>,
    position: number,
    isTrailer: boolean,
  ) {
    this.properties = {
      master_id: title.masterId,
      content_title: title.originalTitle,
      content_type: title.type,
      genres: title.genres,
      episode_number: title.type === 'episode' ? title.episode.sequenceNumber : undefined,
      season_number: title.type === 'episode' ? title.season.sequenceNumber : undefined,
      series_id: title.type === 'episode' ? title.series.masterId : undefined,
      provider_title_id: playbackOption.providerTitleId,
      service_name: playbackOption.providerName,
      service_type: playbackOption.serviceType,
      referral_id: title.type === 'series' || title.type === 'episode' ? title.series.masterId : title.masterId,
      bookmark_seconds: position,
      bookmark_percent:
        title.duration !== undefined && title.duration !== null
          ? Math.round(getPercent(position, title.duration))
          : undefined,
      is_trailer: isTrailer,
    };
  }
}
